import(/* webpackMode: "eager" */ "/home/ubuntu/download/69b262c2886e100014f5867d/easymedical/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69b262c2886e100014f5867d/easymedical/src/app/products-services/components/ImagingSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69b262c2886e100014f5867d/easymedical/src/app/products-services/components/IVDSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69b262c2886e100014f5867d/easymedical/src/app/products-services/components/LifeSupportSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69b262c2886e100014f5867d/easymedical/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69b262c2886e100014f5867d/easymedical/src/components/ui/AppLogo.tsx");
